var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adaptive-modal',{attrs:{"name":"delivery-project-details","hide-action-buttons":true},on:{"before-open":_vm.beforeOpen}},[(_vm.deliveryProject)?_c('span',[_c('strong',[_vm._v("Leveransprojekt:")]),_vm._v(" "+_vm._s(_vm.deliveryProject.name)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }